import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { isNumber } from 'modules/core/lib/validateNumberInput'

class EmployeeCodeConfigurationForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      id: 'string',
      code_prefix: 'string',
      next_value: 'number',
      company_id: 'string',
    })
    makeObservable(this, {
      isNextValueValid: computed,
      isPrefixValid: computed,
      isFinalCodeValid: computed,
      isInputValid: computed,
    })
  }

  get isPrefixValid(): boolean {
    const prefix = this.get('code_prefix').value
    const regex = /^[A-Z]{0,3}$/

    return regex.test(prefix)
  }

  get isNextValueValid(): boolean {
    const nextValue = this.get('next_value').value

    return nextValue.length <= 6 && isNumber(nextValue)
  }

  get isFinalCodeValid(): boolean {
    const nextValue = this.get('next_value').value
    const prefix = this.get('code_prefix').value

    return nextValue.length + prefix.length <= 6
  }

  get isInputValid(): boolean {
    return this.isFinalCodeValid && this.isNextValueValid && this.isPrefixValid
  }
}

export default EmployeeCodeConfigurationForm
